export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 120,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_title_order_No') || '订单编号',
    field: 'orderNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_cust_order_No') || '客户订单编号',
    field: 'custOrderNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_identify_No') || '识别单号',
    field: 'identifyNo',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    title: that.$l('table_label_productLine') || '产品线',
    field: 'v_productLine',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_order_status') || '订单状态',
    width: 100,
    align: 'center',
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_order_customer') || '下单客户',
    field: 'custName',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_executive_customer') || '执行客户',
    field: 'endCustName',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_order_issue_type') || '下单方式',
    field: 'v_issueType',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_order_shipment_type') || '出运方式',
    field: 'v_shipmentType',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_sales_person_name') || '业务人员名字',
    field: 'salesPersonName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_order_type') || '订单类型',
    field: 'v_orderType',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_order_source') || '订单来源',
    field: 'v_orderSource',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_delivery_day') || '交货日期',
    field: 'deliveryDay',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_currency_unit') || '货币单位',
    field: 'v_currencyUnit',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_order_amount') || '订单总价',
    field: 'orderAmount',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_sales_season') || '销售季节',
    field: 'v_salesSeason',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_delivery_port') || '交货港口',
    field: 'v_deliveryPort',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_delivery_port') || '交货地址',
    field: 'deliveryAddress',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_factory_payment_terms') || '工厂付款条件',
    field: 'factoryPaymentTerms',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_technologyLevel') || '工艺难度',
    field: 'v_technologyLevel',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_technology_Level_desc') || '工艺难度说明',
    field: 'technologyLevelDesc',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_importanceLevel') || '重要级别',
    field: 'v_importanceLevel',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_importanceLevel_desc') || '重要级别说明',
    field: 'importanceLevelDesc',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_urgentLevel') || '紧急程度',
    field: 'v_urgentLevel',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_urgentLevel_desc') || '紧急程度说明',
    field: 'urgentLevelDesc',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_order_remark') || '订单备注说明',
    field: 'orderRemark',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_customer_notification_time') || '客户通知时间',
    field: 'customerNotificationTime',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_customer_comfirm_time') || '客户确认时间',
    field: 'customerComfirmTime',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_submitBy_name') || '提交人',
    field: 'submitByName',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_submit_time') || '提交时间',
    field: 'submitTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_reviewBy_name') || '审核人',
    field: 'reviewByName',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_review_time') || '审核时间',
    field: 'reviewTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_biz_person') || '跟单人员',
    field: 'bizPersonName',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'createByName',
    align: 'center',
    width: 100,
    title: that.$l('INDEX.creator') || '创建人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'createTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.create_date') || '创建时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyByName',
    align: 'center',
    width: 100,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
